import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import hoursReducer from './slices/hoursSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    hours: hoursReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
